import { INSTALLMENT_PLANS } from 'src/constants/learn-more';
import { type CurrencyType } from 'src/types/currency';
import { getFormattedAmount } from 'src/utils/get-formatted-amount';

const FEE_PERCENTAGE = {
  [INSTALLMENT_PLANS.six]: 0.05,
  [INSTALLMENT_PLANS.eight]: 0.09,
  [INSTALLMENT_PLANS.twelve]: 0.17,
};

type InstallmentCount = keyof typeof FEE_PERCENTAGE;

export function calculateFeesByPrice(
  price,
  installmentCount: InstallmentCount,
  currency: CurrencyType
) {
  return getFormattedAmount(price * FEE_PERCENTAGE[installmentCount], currency);
}

export function calculatePriceWithFees({
  price,
  installmentCount,
}: {
  price: number;
  installmentCount: InstallmentCount;
}) {
  return price * FEE_PERCENTAGE[installmentCount] + price;
}
